export const _CONTRACT_DATA = {
  bsc: {
    bnb: {
      //testnet_v1.1: '0xf21452bC0709f2Af5701ee8AD1704e1A38abbfeD',
      //testnet_v1.2: '0x93Fc709897174E27C157C9B25D4877692dB355bC',
      //testnet_v2:   '0xAE01C6a87CeB23874b8Dc8Fa7DCB926e641A1277',
      //mainnet_v1.2: '0x7B43d384fD83c8317415abeeF234BaDec285562b',
      //mainnet_v2:   '0x76f2c7c0DeDca9B693630444a9526e95B3A6918e',
      testnet: '0x00C3b3E90f2c960D711891B3BD57917c7ACf4B15',
      mainnet: '0x00C3b3E90f2c960D711891B3BD57917c7ACf4B15',
    },
    /*
    bnb_legacy: {
      mainnet: '0x76f2c7c0DeDca9B693630444a9526e95B3A6918e', // V2 contract, for history page
      testnet: null,
    },
    */
    btc: {
      //mainnet_v2: '0x93Fc709897174E27C157C9B25D4877692dB355bC',
      testnet: '0xd276811B0eAE4cDB0651343976f727949769eC6C',
      mainnet: '0xAfA97b96325AA5595061018f6AA3F64C612a83d9',
    },
    /*
    btc_legacy: {
      mainnet: '0x93Fc709897174E27C157C9B25D4877692dB355bC', // V2 contract, for history page
      testnet: null,
    },
    */
    referrals: {
      testnet: '0x70bBD4fa9d768379d70267C9Ec21627d108F89b8',
      mainnet: '0x6D9dFe3aD151E47681380Bd9ec04A9d6ED51E129',
    },
  },

  polygon: {
    btc: {
      testnet: '0x7B43d384fD83c8317415abeeF234BaDec285562b',
      mainnet: null,
    },
    referrals: {
      testnet: '0x6a6094dbD1d8d244899D78B41E1D8C1fa6A5873a',
      mainnet: null,
    }
  },

  dogechain: {
    btc: {
      testnet: '0x7B43d384fD83c8317415abeeF234BaDec285562b',
      mainnet: '0x7B43d384fD83c8317415abeeF234BaDec285562b',
    },
    doge: {
      testnet: null,
      mainnet: '0x6a6094dbD1d8d244899D78B41E1D8C1fa6A5873a',
    },
    referrals: {
      testnet: '0x6a6094dbD1d8d244899D78B41E1D8C1fa6A5873a',
      mainnet: '0x134eb9954A91b5C3cdC386B590a26C8Eb0dC0D01',
    }
  }
};
